import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../store/store";

const HeaderScreen = () => {
    const { copyright } = useSelector((state: RootState) => {
        return state.globalDataSlice.Global;
    });
    return (
        <>
            <footer className="footer common-padd-lt-rt">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 p-0"><p>{copyright}</p></div>
                        <div className="col-sm-6 p-0 terms-privacy">
                            <ul>
                                <li><Link to='/terms-conditions'>Terms & Conditions</Link></li>
                                <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
export default HeaderScreen;